import { teamSchema } from '@scalar-org/entities/team'

import { z } from 'zod'

import type { getDatabaseClient } from '@/helpers'

export const getUserTeams = (
  client: Awaited<ReturnType<typeof getDatabaseClient>>,
  email: string,
) => {
  return client.getMany({
    collectionPath: 'team',
    query: { email },
    schema: z.array(teamSchema),
  })
}
